import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autosubmit"
export default class extends Controller {
  static targets = ["input"]

  connect() {
  }

  handleKeydown(event) {
    console.log("Key pressed:", event.key);
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault(); // Prevent the default behavior (e.g., adding a newline in a textarea)
      this.element.requestSubmit();   
      this.inputTarget.value = ""; 
    }
  }
}
